import { render, staticRenderFns } from "./wxaccount.vue?vue&type=template&id=6d054aac&"
import script from "./wxaccount.vue?vue&type=script&lang=js&"
export * from "./wxaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports